const AUTH_ERROR_MARKERS = ['401', 'Unauthorized', 'аутентификации'];
const RATE_LIMIT_MARKERS = ['429', 'Rate Limit', 'много запросов'];

function errorContains(error: Error, markers: string[]): boolean {
  return markers.some((marker) => error.message.includes(marker));
}

/**
 * Классифицирует ошибку загрузки RBAC-данных
 * и возвращает человекочитаемое сообщение.
 */
export function classifyRbacError(error: unknown): string {
  if (!(error instanceof Error)) {
    return 'Не удалось загрузить права пользователя';
  }

  if (errorContains(error, AUTH_ERROR_MARKERS)) {
    return 'Ошибка авторизации. Попробуйте обновить страницу.';
  }

  if (errorContains(error, RATE_LIMIT_MARKERS)) {
    return 'Сервер временно перегружен. Попробуйте через несколько секунд.';
  }

  return 'Не удалось загрузить права пользователя';
}
